<template>
  <header class="root-header">
    <div class="root-header-content clear-both">
      <pb-float float="left">
        <back-button v-if="visible_back" />
      </pb-float>
      <pb-float float="right">
        <router-link to="/campaigns">광고목록</router-link>
        <router-link v-if="admin" to="/users">광고주 관리</router-link>
        <router-link to="/logout">로그아웃</router-link>
      </pb-float>
    </div>
  </header>
</template>
<script>
import BackButton from "./BackButton";

export default {
  name: "RootHeader",
  props: {
    admin: Boolean
  },
  components: {
    BackButton
  },
  computed: {
    visible_back() {
      return /\/(campaign)\//.test(this.$route.path);
    }
  }
};
</script>
<style lang="scss">
@import "~styles/color";
@import "~styles/size";

header {
  position: fixed;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background-color: $black;
  z-index: 999;

  .root-header-content {
    max-width: $max_layout;
    margin: 0 auto;
    padding: 0 16px;

    a {
      color: #ffffff;
      text-decoration: none;
      font-size: 1.3rem;

      &:visited,
      &:hover {
        color: #ffffff;
      }

      & + a {
        margin-left: 1.6rem;
      }
    }
  }
}
</style>
